import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../shared/my-constants';
import {Observable} from 'rxjs/Observable';

//  import * as webapi from '../../assets/js/webproperty.js';
@Injectable()
export class loginService {
  city: any;
  hasCreateAccess = true;
  hasEditAccess = true;
  hasDeleteAccess = true;
  private loginurl = webapi + 'loginaction/authuserlogin1/';
  private unitListUserwise = webapi + 'mst_staff/unitlistuserwise1/?';
  private addRecord = webapi + 'license-agreement/create';

  constructor(private http: Http) {
  }

  addRecordService() {
    let headers = new Headers({'Content-Type': 'application/json'});
    return this.http.post(this.addRecord, {headers: headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  loginAction(value): Observable<any> {
    let headers = new Headers({'Content-Type': 'application/json'});
    return this.http.post(this.loginurl, JSON.stringify(value), {headers: headers})
      .map(response => response.json());
  }

  getUnitListByUsername(username) {
    return this.http.get(this.unitListUserwise + 'username=' + username)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/login/login.service.ts